import { render, staticRenderFns } from "./MallV2Preview.vue?vue&type=template&id=1fe16f14&scoped=true"
import script from "./MallV2Preview.vue?vue&type=script&lang=js"
export * from "./MallV2Preview.vue?vue&type=script&lang=js"
import style0 from "./MallV2Preview.vue?vue&type=style&index=0&id=1fe16f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe16f14",
  null
  
)

export default component.exports